import React, { useState } from "react";
import "./WorksiteLinking.scss";
import WorksiteLinkingModal from "./WorksiteLinkingModal";

const WorksiteLinking = (props) => {
  const {
    schemaProps: { disabled, formId, buttonLabel, buttonText, onSubmit },
    formApi,
    counties,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const worksites = formApi.getState().values["appx_b_worksites"];

  return (
    <>
      <div className="grid-row worksite-linking-dd-container">
        <div className=" grid-col-12 worksite-linking-dd">
          <span className="worksite-linking-text">{buttonLabel}</span>
          <button
            type="button"
            className="usa-button worksite-linking-btn"
            disabled={!!disabled}
            onClick={() => setModalOpen(true)}
          >
            {buttonText}
          </button>
        </div>
      </div>
      <WorksiteLinkingModal
        formId={formId}
        modalOpen={modalOpen}
        toggleModal={() => setModalOpen(false)}
        onSubmit={onSubmit}
        worksites={worksites}
        setFieldValue={formApi.change}
        counties={counties}
        formApi={formApi}
      />
    </>
  );
};

export default WorksiteLinking;
